import React, { Fragment } from 'react';
import PublishingCompany from '../../components/PublishingCompany/PublishingCompany';
import Authors from '../../components/Authors/Authors';
import NewBooks from '../../components/NewBooks/NewBooks';
import Publish from '../../components/Publish/Publish';
import Contact from '../../components/Contact/Contact';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import BackToTop from '../../components/BackToTop/BackToTop';
import Manutencao from '../../components/Manutencao/';
export default class Home extends React.Component {

    constructor(props) {
        super(props);
        window.scrollTo(0,0);

        {
        /*
        <Header   history={this.props.history}  />
        <PublishingCompany/>
        <Authors/>
        <NewBooks history={this.props.history}/>
        <Publish  history={this.props.history}/>
        <Contact/>
        <Footer history={this.props.history}/>
        <BackToTop/>
        */
        }
    }



    render() {
        return (
            <Fragment>
              <Header   history={this.props.history}  />
              <PublishingCompany/>
              <Authors/>
              <NewBooks history={this.props.history}/>
              <Publish  history={this.props.history}/>
              <Contact/>
              <Footer history={this.props.history}/>
              <BackToTop/>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Home/index.js